import { render, staticRenderFns } from "./childAccount.vue?vue&type=template&id=44416cf0&scoped=true"
import script from "./childAccount.vue?vue&type=script&lang=js"
export * from "./childAccount.vue?vue&type=script&lang=js"
import style0 from "./childAccount.vue?vue&type=style&index=0&id=44416cf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44416cf0",
  null
  
)

export default component.exports